import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3DatePicker, NoResult, Alert, Confirm } from "../../../js/ComponentManager";
import { Big3Common, bootstrap } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능: 일괄주문 리스트
 * 세부설명:
*/

export class OrderExcelList extends Component {
    static displayName = OrderExcelList.name;

    constructor(props) {
        super(props);
        let fromDate = format(Big3Common.Util.DateAdd(new Date(), -3), "yyyy-MM-dd");
        let toDate = format(Big3Common.Util.DateAdd(new Date(), 1), "yyyy-MM-dd");
        this.state = {
            FromDate: fromDate,
            ToDate: toDate,
            ExcelOrderList: [],
            Bill_Yn: "N",
            Refund_Yn: "N",
            Title:""
        };
        this.handleCalendar_Change = this.handleCalendar_Change.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleDetail_Click = this.handleDetail_Click.bind(this);
        this.handleDownload_Click = this.handleDownload_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    async componentDidMount() {
        await this.GetOrderDate();
        this.CallOrderExcelMstList();
        if (this.Uid_Type === 'TS') {
            /*this.GetRefund();*/
            this.GetbillingKey();
        }
    }
    handleCalendar_Change(retunData) {
        this.setState({ [retunData.returnId]: retunData.SelectDate });
    }
    //사입일자 가져오기
    async GetOrderDate() {

        try {
            let Data1 = await Big3Common.Get('api/Common/Common/GetOrderDate');
            if (Data1.codeName === Big3Common.ResultCode.Success) {
                const toData = Data1.message;
                let fromDate = format(Big3Common.Util.DateAdd(new Date(toData), -3), "yyyy-MM-dd");
                this.setState({
                    ToDate: toData,
                    FromDate: fromDate
                });
            }
        }
        catch (e) {
            console.log("GetOrderDate", e);
        }
        return false;
    }
    //카드등록확인
    async GetbillingKey() {
        try {
            //주문유형 
            let Data = await Big3Common.Post('api/Common/Common/GetbillingKey', {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let Bill_Yn = "Y"
                this.setState({ Bill_Yn: Bill_Yn });

            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetbillingKey", e);
        }
        return false;
    }
/*    //환불요청 확인
    async GetRefund() {
        try {
            let Data = await Big3Common.Post("api/Common/Common/GetRefund", {}, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                const Refund_Yn = DataList[0]["refund_yn"]
                this.setState({
                    Refund_Yn: Refund_Yn
                })
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("GetRefundCount: ", e)
        }
        return false;
    }*/
    //일괄주문 리스트 조회
    CallOrderExcelMstList = async () => {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/GetOrderExcelMstList',
                {
                    ToDate: this.state.ToDate,
                    FromDate: this.state.FromDate
                }, true
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const ExcelOrderList = JSON.parse(Data.dataTable);
                this.setState({
                    ExcelOrderList: ExcelOrderList
                });
            }
            else {
                this.setState({
                    Title: Data.message
                });
                Big3Common.ModalAlert(bootstrap, 'OrderExcelListAlert');
            }
        }
        catch (e) {
            console.log("CallOrderExcelMstList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //검색버튼 클릭
    handleSearch_Click() {
        this.CallOrderExcelMstList();
        return false;
    }
    //그리드 이동
    handleDetail_Click(event,list) {
        this.props.RenderComponent("OrderExcelTable", {
            Order_Dt: list.order_dt
        });
        event.preventDefault();
    }
    //삭제버튼 클릭
    handleConfirm_Click(event, list) {
        this.DeleteModel.order_dt = list.order_dt;
        this.DeleteModel.union_uid = list.union_uid;
        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
        event.preventDefault();
    }
    handleOrder_Click() {
        if (this.Uid_Type === 'TS') {
            if (this.state.Bill_Yn === 'N') {
                this.setState({ Title: "카드 등록 후 주문이 가능합니다." });
                Big3Common.ModalAlert(bootstrap, "OrderExcelListAlert");
                return false;
            }
            /*        else if (this.state.Refund_Yn === 'Y') {
                        this.setState({ Title: "환불 진행중에는 주문이 불가능합니다." });
                        Big3Common.ModalAlert(bootstrap, "OrderExcelListAlert");
                        return false;
                    }*/
            else if (this.state.Bill_Yn === 'Y' && this.state.Refund_Yn === 'N') {
                this.props.RenderComponent("OrderExcelTable");
            }
        }
        else {
            this.props.RenderComponent("OrderExcelTable");
        }
    }
    DeleteModel = {
        order_dt: "",
        union_uid: ""
    }
    //삭제 호출
    async handleDelete_Click() {       

        try {
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/RemoveOrderExcel',{
                    order_dt: this.DeleteModel.order_dt
            });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Title: Data.message });
                Big3Common.ModalAlert(bootstrap, 'OrderExcelListAlert');
                this.CallOrderExcelMstList();
            }           
        }
        catch (e) {
            console.log("handleDelete_Click", e);
        }
        finally {
            this.DeleteModel.order_dt = "";
            this.DeleteModel.union_uid = "";
        }
    }
    handleDownload_Click = async (event) => {
        try {
            const fileName = "클로디_대량주문_Sample.xlsx";
            let Url = "api/MyPage/ExcelOrder/ExcelSampleDownload"
            await Big3Common.FileDownLoad(Url, fileName);
        }
        catch (e) {
            console.log("handleDownLoad_Click", e);
        }
        event.preventDefault();
    }
    //주문 리스트 목록
    OrderListrender = () => {
        const ExcelOrderList = this.state.ExcelOrderList;
        this.CompleteYn = (list) => {
            const conf_y = list.conf_y;
            const conf_n = list.conf_n;
            const total = conf_y + conf_n;
            if (conf_n === 0) {
                return (
                    <div className="upload_complete">사입요청</div>
                )
            }
            else {
                if (total === conf_n) {
                    //1개도 사입요청이 안될 경우
                    return (
                        <div className="uploading">작성중
                            <span className="delete_data" onClick={(e) => { this.handleConfirm_Click(e, list) }}></span>
                        </div>
                    )
                }
                else {
                    //사입요청 건도 있고, 작성건도 있는 경우
                    return (
                        <div className="uploading">작성중</div>
                    )
                }
                
            }
        }
        this.Whole_Count = (list) => {
            const Count = list.conf_y + list.conf_n;
            if (Count === 1) {
                return (
                    list.whole_name
                )
            }
            else {
                return (
                    `${list.whole_name} 외 ${Count-1}곳`
                )
            }
        }
        return (
            <div className="excel_order_list">
                {ExcelOrderList.map(list =>
                    <div className="excel_order" key={list.order_dt} onClick={(e) => { this.handleDetail_Click(e, list) } }>
                        <div className="excel_order_info_box">
                            <div className="date">{list.format_order_dt}</div>
                            {this.CompleteYn(list) }
                        </div>
                        <div className="excel_order_info_box">
                            <div className="excel_oreder_info_tit">도매업체</div>
                            <div className="excel_oreder_info_cont">{this.Whole_Count(list)}</div>
                        </div>
                        <div className="excel_order_info_box">
                            <div className="excel_oreder_info_tit">총 주문 수</div>
                            <div className="excel_oreder_info_cont">{list.conf_y + list.conf_n}건</div>
                            <div className="Upload Complete"></div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
    render() {
        return (
            <div>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap" onClick={() => { this.props.RenderComponent("OrderStoreList"); }}><div className="alert_tap">스토어</div></div>
                    <div className="n_tap"><div className="alert_tap  tap_on" >일괄주문</div></div>
                </div>
                <div className="container_box2 order_list_v3">
                    <div className="title_box pc_v">
                        <div className="title">일괄주문</div>
                    </div>
                    <div className="excel_order_btn_box pc_v">
                        <div className="excel_order_btn" onClick={(e) => { this.handleDownload_Click(e) } }>
                            <span className="excelicon"></span>
                            <p>엑셀양식 다운로드</p>
                        </div>
                        <div className="excel_order_btn" onClick={() => { this.handleOrder_Click() }}>
                            <span className="upload"></span>
                            <p>일괄주문 등록</p>
                        </div>
                    </div>
                </div>
                <div className="line_v2"></div>
                <div className="container_box2 order_list_v4">
                    <div className="title_box"><div className="title">일괄주문 리스트</div></div>
                    <div className="search_box_v4">
                        <div className="select_date_box">
                            <div className="select_date_box_input">
                                <div>
                                    <Big3DatePicker
                                        className="form-control"
                                        setDate={new Date(this.state.FromDate)}
                                        DateChange={this.handleCalendar_Change}
                                        id="FromDate"
                                    />
                                    <div className="calendar_btn pointer"></div>
                                </div>
                            </div>
                            <div className="select_date_box_input">
                                <div>
                                    <Big3DatePicker
                                        className="form-control"
                                        setDate={new Date(this.state.ToDate)}
                                        DateChange={this.handleCalendar_Change}
                                        id="ToDate"
                                    />
                                    <div className="calendar_btn pointer"></div>
                                </div>
                            </div>
                            <button type="button" className="date_s_btn" onClick={() => { this.handleSearch_Click(); } }>조회</button>
                        </div>
                        {this.OrderListrender() }
                    </div>
                </div>
                <NoResult
                    Text="검색결과가 없습니다."
                    Visible={this.state.ExcelOrderList.length === 0 ? true : false}
                    Top={"60%"}
                />
                <Alert
                    title={this.state.Title}
                    id="OrderExcelListAlert"
                />
                <Confirm
                    id="ConfirmBox"
                    title="삭제안내"
                    content="주문을 삭제하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleDelete_Click();
                    }}
                />
            </div>
        );
    }
}
